module.exports = {"id":"160741","name":"David Abraham","rating":"79","photo":"./data/images/photos/2/160741.png","club":{"name":"Eint. Francfort","logo":"./data/images/clubs/Eint.Francfort.png"},"positions":["DC"],"photoFolderIndex":2}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/DavidAbraham0.json
// module id = 985
// module chunks = 0